"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Gentoo = function Gentoo(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.956.097a7.252 7.252 0 0 0-1.25.115C4.397 1 1.365 4.73 1.107 7.186c-.125 1.205.525 2.108.883 2.506.969 1.076 2.9 1.898 4.141 2.58-1.795 1.53-2.618 2.277-3.429 3.128-1.214 1.274-2.067 2.676-2.07 3.68 0 .323-.053 1.355.368 2.17.158.306.608 1.327 1.964 2.092.867.49 2.102.67 3.31.497 3.742-.534 8.753-3.707 12.328-6.662 2.279-1.884 3.945-3.709 4.426-4.607.388-.725.431-2.026.206-2.843-.64-2.318-5.84-7.067-10.091-8.978A7.761 7.761 0 0 0 9.956.097zm-.007.067a7.341 7.341 0 0 1 3.317.749c3.433 1.687 9.233 6.43 9.661 8.814.53 2.948-9.852 10.929-16.167 12.174-2.45.481-4.539.613-5.492-1.975-.826-2.243.776-3.884 3.135-6.04.98-.895 1.76-1.564 2.935-2.556.065-.068-5.66-2.042-5.842-4.308C1.307 4.693 4.995.394 9.716.172c.078-.004.155-.007.233-.008zM9.838.68a5.602 5.602 0 0 0-.502.031c-2.319.244-2.763.543-4.864 2.132-.704.533-2 1.829-2.331 3.366-.127.586.023 1.091.444 1.446 1.35 1.135 3.61 2.056 5.465 2.947.543.26.184.733-.692 1.492-2.21 1.913-5.198 4.242-5.407 6.017-.098.836.188 1.972 1.203 2.554 1.186.679 3.647.236 5.291-.376 2.402-.895 5.557-2.869 8.062-4.809 2.604-2.018 5.026-4.58 5.146-4.998.147-.513.132-.988-.152-1.533-.445-.855-1.041-1.491-1.681-2.203-1.718-1.81-3.534-3.401-5.708-4.62-1.423-.798-2.69-1.47-4.274-1.446zm1.066 3.594c.542 0 1.167.171 1.838.496 1.675.81 3.395 2.937-.015 4.161-.927.333-3.869-.818-3.779-2.388.089-1.558.847-2.27 1.956-2.269zm.283 1.356c-.315-.002-.571.078-.689.26-.552.855-.3 1.461.211 1.848.19-.454 2.138.042 2.13.468.02-.01.04-.02.055-.032 1.69-1.272-.468-2.536-1.707-2.544z"
  }));
};

Gentoo.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Gentoo.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Gentoo;
exports["default"] = _default;